/**
 * Converte a chave pública da credencial para o PEM que o parceiro realmente usa.
 *
 * O gateway grava a chave em base64 (`Util.encodeBase64` no cadastro), então o valor que chega
 * na listagem NÃO é um PEM — colar aquilo numa integração não funciona. Aqui ele volta ao
 * formato original.
 *
 * Valor que não decodifica é devolvido como veio: melhor mostrar o dado cru do que quebrar a
 * tela ou fingir que não há chave. Credencial criada por outro caminho pode já estar em PEM.
 *
 * @param encoded Valor de `publicKey` como veio da API.
 * @returns O PEM, ou string vazia quando não há chave.
 */
export const decodePublicKey = (
  encoded?: string
): string => {
  const value = encoded?.trim()
  if (!value) return ""
  if (value.startsWith("-----BEGIN")) return value

  try {
    const decoded = atob(value)
    return decoded.includes("-----BEGIN") ? decoded : value
  } catch {
    return value
  }
}
